var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "modal-container has-background-petBlue" }, [
      _c("div", { staticClass: "modal-header" }, [
        _c("span", { staticClass: "has-text-weight-bold" }, [
          _vm._v(
            _vm._s(_vm.nORe == "e" ? "" : "New") +
              " " +
              _vm._s(_vm.editingSub ? "Subslink" : "Slink") +
              " " +
              _vm._s(_vm.nORe == "e" ? "Settings" : "")
          )
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "delete is-large is-pulled-right",
          on: { click: _vm.doClose }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body" }, [
        _c("div", { staticClass: "slinkContainerOpen" }, [
          _c(
            "span",
            { staticClass: "has-text-warning has-text-weight-bold is-size-4" },
            [_vm._v("»")]
          ),
          _c(
            "div",
            { staticClass: "has-text-primary is-size-4  is-inline-block" },
            [_vm._v(_vm._s(_vm.slink) + _vm._s(_vm.editingSub ? ":" : ""))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "has-text-turk  is-size-6" }, [
            _vm._v("slink.com/"),
            _c("b", [
              _vm._v(
                _vm._s(_vm.slink) +
                  _vm._s(_vm.editingSub ? ":" : "") +
                  _vm._s(_vm.newName)
              )
            ])
          ]),
          _vm._v("  \n\n                "),
          _vm.editingSub
            ? _c("div", [
                _vm._m(0),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editingSub,
                      expression: "editingSub"
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newName,
                      expression: "newName"
                    }
                  ],
                  staticClass: "inlineInput ",
                  attrs: {
                    id: "newSubName",
                    type: "text",
                    placeholder: "enter word"
                  },
                  domProps: { value: _vm.newName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newName = $event.target.value
                    }
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "top10" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "top5" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.rOption,
                      expression: "rOption"
                    }
                  ],
                  staticClass: "inlineSelect",
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.rOption = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.selectChanged
                    ]
                  }
                },
                [
                  _c("option", { attrs: { value: "1" } }, [_vm._v("URL")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "2" } }, [_vm._v("Phone")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "3" } }, [_vm._v("Email")]),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.editingSub,
                          expression: "!editingSub"
                        }
                      ],
                      attrs: { value: "4" }
                    },
                    [_vm._v("SlinkPage")]
                  )
                ]
              ),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.target < 4,
                    expression: "target < 4"
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newUrl,
                    expression: "newUrl"
                  }
                ],
                ref: "ta",
                staticClass: "inlineTextArea",
                attrs: { id: "urlTextArea", placeholder: "enter URL" },
                domProps: { value: _vm.newUrl },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.newUrl = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            !_vm.editingSub
              ? _c("div", { staticClass: "has-text-turk is-size-6 top10" }, [
                  _c("b", [_vm._v("Description: ")]),
                  _vm._v("(appears on SlinkPage)")
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.editingSub
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newSlinkDesc,
                      expression: "newSlinkDesc"
                    }
                  ],
                  ref: "descriptionSlink",
                  staticClass: "inlineInput desc top5",
                  class: { disabled: !_vm.newLinksPage },
                  attrs: {
                    maxlength: "150",
                    disabled: !_vm.newLinksPage,
                    type: "text",
                    placeholder: _vm.newLinksPage ? "enter description" : "--"
                  },
                  domProps: { value: _vm.newSlinkDesc },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newSlinkDesc = $event.target.value
                    }
                  }
                })
              : _vm._e(),
            _c("br"),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.target == 4,
                    expression: "target == 4"
                  }
                ],
                staticClass: "has-text-primary top5 padSides"
              },
              [
                _c("b", [
                  _vm._v("Your slink will point directly to your SlinkPage.")
                ]),
                _vm._v(
                  " Keep in mind that, if turned on, your SlinkPage is always avaialable at "
                ),
                _c(
                  "span",
                  { staticClass: "has-text-warning has-text-weight-bold" },
                  [_vm._v("»")]
                ),
                _c("b", [_vm._v("songwriter:links")]),
                _vm._v(
                  ",\n                    regardless of where you point your slink."
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showErrMsg,
                  expression: "showErrMsg"
                }
              ],
              staticClass: "has-text-danger"
            },
            [_vm._v(_vm._s(_vm.errMsg))]
          ),
          _vm._v(" "),
          _vm.editingSub
            ? _c("div", [
                _c("div", { staticClass: "topBorder" }, [_vm._v(" ")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "has-text-dark is-inline-block is-size-5" },
                  [_vm._v("Show on SlinkPage:")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "is-inline-block" },
                  [
                    _c("VueToggles", {
                      staticClass: "left5",
                      attrs: {
                        value: _vm.newShowInLinksPage,
                        width: "50",
                        checkedBg: "#50abc7",
                        checkedText: "on",
                        uncheckedText: "off"
                      },
                      on: {
                        click: function($event) {
                          _vm.newShowInLinksPage = !_vm.newShowInLinksPage
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.editingSub
                  ? _c(
                      "div",
                      { staticClass: "has-text-turk is-size-6 top10" },
                      [
                        _c("b", [_vm._v("Description: ")]),
                        _vm._v("(appears on SlinkPage)")
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.linksPage && _vm.newShowInLinksPage,
                        expression: "!linksPage && newShowInLinksPage"
                      }
                    ],
                    staticClass: "has-text-grey"
                  },
                  [
                    _vm._v("Note: the SlinkPage for the slink "),
                    _c("b", [_vm._v(_vm._s(_vm.slink))]),
                    _vm._v(" is currently off.")
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.editingSub
            ? _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newDescription,
                    expression: "newDescription"
                  }
                ],
                ref: "description",
                staticClass: "inlineInput desc left-5 top5 ta2rows",
                class: { disabled: !_vm.newShowInLinksPage },
                attrs: {
                  maxlength: "150",
                  disabled: !_vm.newShowInLinksPage,
                  type: "text",
                  placeholder: _vm.newShowInLinksPage
                    ? "enter description"
                    : "--"
                },
                domProps: { value: _vm.newDescription },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.newDescription = $event.target.value
                  }
                }
              })
            : _vm._e(),
          _c("br"),
          _vm._v(" "),
          !_vm.editingSub
            ? _c("div", [
                _c("div", { staticClass: "topBorder top30" }, [_vm._v(" ")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "has-text-dark is-inline-block is-size-5" },
                  [_vm._v("SlinkPage:")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "is-inline-block" },
                  [
                    _c("VueToggles", {
                      staticClass: "left5",
                      attrs: {
                        value: _vm.newLinksPage,
                        width: "50",
                        checkedBg: "#50abc7",
                        checkedText: "on",
                        uncheckedText: "off"
                      },
                      on: {
                        click: function($event) {
                          _vm.newLinksPage = !_vm.newLinksPage
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "has-text-dark top10" }, [
                  _vm._v(
                    'The SlinkPage is a landing page that lists all of this Slink\'s subslinks with their descriptions. It is a convienient way to publish your slink eco-system to use in a "link in bio", por example. If turned on, it can be reached at '
                  ),
                  _c(
                    "b",
                    {
                      staticClass: "handCursor",
                      on: { click: _vm.navToLinks }
                    },
                    [_vm._v("slink.com/" + _vm._s(_vm.slink) + ":links")]
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.editingSub,
                  expression: "!editingSub"
                }
              ],
              staticClass: "has-text-turk is-size-6 top10"
            },
            [_c("b", [_vm._v("SlinkPage Description:")])]
          ),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.editingSub,
                expression: "!editingSub"
              },
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newPageDesc,
                expression: "newPageDesc"
              }
            ],
            staticClass: "inlineTextArea2 ta2rows ",
            class: { disabled: !_vm.newLinksPage },
            attrs: {
              disabled: !_vm.newLinksPage,
              placeholder: "enter description"
            },
            domProps: { value: _vm.newPageDesc },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.newPageDesc = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "top20" }, [
            !_vm.sure && _vm.nORe == "e" && _vm.editingSub
              ? _c("div", { staticClass: "is-inline-block" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button left-5",
                      on: {
                        click: function($event) {
                          _vm.sure = true
                        }
                      }
                    },
                    [_vm._v("Delete")]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.sure && _vm.nORe == "n"
              ? _c("div", { staticClass: "is-inline-block" }, [_vm._v(" ")])
              : _vm._e(),
            _vm._v(" "),
            _vm.sure
              ? _c("div", { staticClass: "is-inline-block" }, [
                  _c(
                    "span",
                    { staticClass: "has-text-dark top3 is-inline-block" },
                    [_vm._v("Sure? ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button is-warning is-small",
                      attrs: { id: "yesButt" },
                      on: { click: _vm.deleteSub }
                    },
                    [_vm._v("Yes")]
                  ),
                  _vm._v(" \n                        "),
                  _c(
                    "button",
                    {
                      staticClass: "button is-small",
                      on: {
                        click: function($event) {
                          _vm.sure = false
                        }
                      }
                    },
                    [_vm._v("No")]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "is-inline-block is-pulled-right" }, [
              _c(
                "button",
                { staticClass: "button right5", on: { click: _vm.doClose } },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "button is-turk", on: { click: _vm.save } },
                [_vm._v("Save")]
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _c("br")
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(2)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "has-text-turk is-size-6" }, [
      _c("b", [_vm._v("Subslink:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "has-text-turk is-size-6" }, [
      _c("b", [_vm._v("Redirect to:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-footer" }, [_c("div")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-616bb2d7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-616bb2d7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalEdit.vue
// module id = null
// module chunks = 